/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ProposedCriterionDeltaOperation } from './proposedCriterionDeltaOperation';

export interface ProposedCriterionDelta {
  operation: ProposedCriterionDeltaOperation;
  id?: string | null;
  label?: string | null;
  description?: string | null;
}
